(function () {
  'use strict';
  var touch = window.matchMedia('(max-width:989px), (max-width:1366px) and (pointer:coarse)');
  var source = document.getElementById('asm-product-ad-config');
  if (!touch.matches || !source || window.__asmProductAdReady) return;
  var config;
  try { config = JSON.parse(source.textContent); } catch (_) { return; }
  if (config.enabled === false) return;
  window.__asmProductAdReady = true;
  var INITIAL_DELAY = 4000, INTERVAL = 60000, DURATION = 8000, CLOSE_DELAY = 4000;
  var KEY = 'asm-product-advertising-v1';
  var products = [], ids = new Set(), nextUrl = config.nextUrl || '', feedPages = new Set();
  var phase = 'idle', elapsed = 0, lastFrame = 0, frame = 0, hiddenAt = 0, exitTimer = 0, hovered = false;
  var controller = null, memory = null, current = null, lastSecond = -1;
  function localUrl(value, product) {
    try {
      var url = new URL(value, location.href);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return '';
      if (product && !/\/products\/[a-z0-9-]+\/?$/.test(url.pathname)) return '';
      return url.pathname + url.search + url.hash;
    } catch (_) { return ''; }
  }
  function imageUrl(value) {
    try {
      var url = new URL(value, location.href);
      return url.protocol === 'https:' || (url.origin === location.origin && url.protocol === 'http:') ? url.href : '';
    } catch (_) { return ''; }
  }
  function append(items) {
    if (!Array.isArray(items)) return;
    items.forEach(function (p) {
      if (!p || products.length >= 1000) return;
      var url = localUrl(p.url, true), image = imageUrl(p.image), id = String(p.id || p.handle || url);
      if (!url || !image || !p.title || ids.has(id)) return;
      ids.add(id);
      products.push({ id: id, title: String(p.title), handle: String(p.handle || ''), url: url, image: image, code: String(p.code || '') });
    });
  }
  append(config.products);
  if (!products.length && !nextUrl) return;
  var allUrl = localUrl(config.allUrl, false);
  var campaign = String(config.version || '') + '|' + String(config.source || '') + '|' + products.map(function (p) { return p.id; }).join(',');
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(memory)); } catch (_) {} }
  function readMemory() {
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (_) {}
    var now = Date.now();
    if (saved && saved.campaign === campaign && Number.isInteger(saved.index) && saved.index >= 0 && saved.index < 1000 && Number.isFinite(saved.nextAt)) {
      return { campaign: campaign, index: saved.index, nextAt: Math.min(saved.nextAt, now + INTERVAL) };
    }
    return { campaign: campaign, index: 0, nextAt: now + INITIAL_DELAY };
  }
  memory = readMemory();
  save();
  var root = document.createElement('aside');
  root.className = 'asm-product-ad';
  root.hidden = true;
  root.setAttribute('aria-label', 'Məhsul reklamı');
  root.innerHTML = '<div class="asm-product-ad__card">' +
    '<header class="asm-product-ad__head"><p class="asm-product-ad__label"></p></header>' +
    '<button type="button" class="asm-product-ad__close" disabled aria-label="4 saniyə sonra bağlamaq olar"><span class="asm-product-ad__lock" aria-hidden="true">4</span><svg viewBox="0 0 24 24" aria-hidden="true" hidden><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
    '<a class="asm-product-ad__product"><img class="asm-product-ad__image" alt="" width="88" height="88"><span class="asm-product-ad__info"><strong class="asm-product-ad__title"></strong><span class="asm-product-ad__code"></span><span class="asm-product-ad__detail">Ətraflı bax <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14m-5-5 5 5-5 5"/></svg></span></span></a>' +
    '<footer class="asm-product-ad__footer"><a class="asm-product-ad__all">Hamısına bax <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14m-5-5 5 5-5 5"/></svg></a><span class="asm-product-ad__remaining" aria-hidden="true">8 san.</span></footer>' +
    '<div class="asm-product-ad__track" aria-hidden="true"><div class="asm-product-ad__progress"></div></div></div>';
  var close = root.querySelector('button'), lock = root.querySelector('.asm-product-ad__lock'), x = close.querySelector('svg');
  var productLink = root.querySelector('.asm-product-ad__product'), image = root.querySelector('img');
  var title = root.querySelector('.asm-product-ad__title'), code = root.querySelector('.asm-product-ad__code');
  var progress = root.querySelector('.asm-product-ad__progress'), remaining = root.querySelector('.asm-product-ad__remaining');
  var all = root.querySelector('.asm-product-ad__all');
  root.querySelector('.asm-product-ad__label').textContent = String(config.label || 'Yeni məhsul');
  if (allUrl) all.href = allUrl; else all.hidden = true;
  document.body.appendChild(root);
  var announcement = document.createElement('span');
  announcement.className = 'visually-hidden';
  announcement.setAttribute('aria-live', 'polite');
  announcement.setAttribute('aria-atomic', 'true');
  document.body.appendChild(announcement);
  function visible(element) { return element && element.getBoundingClientRect().height > 0 && getComputedStyle(element).visibility !== 'hidden'; }
  function blocked() {
    if (!touch.matches || document.hidden) return true;
    if (document.documentElement.matches('.asm-page-cart,.asm-page-quick-order,.asm-page-new-products')) return true;
    if (document.querySelector('.asm-quick-page')) return true;
    if (document.documentElement.classList.contains('asm-popup-open') || /overflow-hidden/.test(document.body.className)) return true;
    var active = document.activeElement;
    if (active && !root.contains(active) && active.matches('input:not([type="button"]):not([type="submit"]),textarea,select,[contenteditable="true"]')) return true;
    var panels = document.querySelectorAll('cart-drawer.active,#cart-notification.active,dialog[open],details.menu-opening,.asm-premium-unit.is-open,.asm-product__choice.is-open,.asm-page-choice.is-open,.asm-search-suggestions:not([hidden]),.asm-touch-help-dialog[open]');
    return Array.from(panels).some(visible);
  }
  function place() {
    var viewport = window.visualViewport, bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    var upperEdge = bottom - 12;
    ['.asm-touch-nav', '.asm-touch-floating-cart'].forEach(function (selector) {
      var element = document.querySelector(selector);
      if (visible(element)) upperEdge = Math.min(upperEdge, element.getBoundingClientRect().top - 12);
    });
    root.style.setProperty('--asm-ad-bottom', Math.max(12, window.innerHeight - upperEdge) + 'px');
  }
  function dismiss(immediate) {
    if (phase !== 'showing') return;
    var focused = root.contains(document.activeElement);
    phase = 'idle';
    cancelAnimationFrame(frame);
    root.classList.remove('is-visible');
    save();
    hovered = false;
    if (focused) {
      var target = document.querySelector('.asm-touch-nav a[aria-current="page"],.asm-touch-nav a');
      if (target) target.focus({ preventScroll: true });
    }
    clearTimeout(exitTimer);
    if (immediate) root.hidden = true;
    else exitTimer = setTimeout(function () { root.hidden = true; }, 430);
    announcement.textContent = '';
  }
  function paint() {
    progress.style.transform = 'scaleX(' + Math.min(1, elapsed / DURATION) + ')';
    var second = Math.ceil(Math.max(0, DURATION - elapsed) / 1000);
    if (second !== lastSecond) { remaining.textContent = second + ' san.'; lastSecond = second; }
    var locked = elapsed < CLOSE_DELAY;
    if (close.disabled !== locked) {
      close.disabled = locked; lock.hidden = !locked; x.hidden = locked;
      close.setAttribute('aria-label', locked ? '4 saniyə sonra bağlamaq olar' : 'Reklamı bağla');
    }
    if (locked) lock.textContent = String(Math.ceil((CLOSE_DELAY - elapsed) / 1000));
  }
  function tick(now) {
    if (phase !== 'showing') return;
    var delta = Math.max(0, now - lastFrame);
    lastFrame = now;
    if (!document.hidden) elapsed = Math.min(DURATION, elapsed + delta);
    paint();
    if (elapsed >= DURATION) dismiss(false);
    else frame = requestAnimationFrame(tick);
  }
  function show(product) {
    if (blocked()) { phase = 'idle'; return; }
    current = product;
    productLink.href = product.url;
    productLink.setAttribute('aria-label', product.title + ' — məhsula bax');
    title.textContent = product.title;
    code.textContent = product.code ? 'Kod: ' + product.code : '';
    code.hidden = !product.code;
    image.src = product.image;
    image.alt = product.title;
    clearTimeout(exitTimer);
    elapsed = 0; lastSecond = -1; hovered = false; close.disabled = true; lock.hidden = false; x.hidden = true;
    close.setAttribute('aria-label', '4 saniyə sonra bağlamaq olar');
    phase = 'showing';
    memory.index += 1;
    memory.nextAt = Date.now() + INTERVAL;
    save();
    paint(); place(); root.hidden = false;
    lastFrame = performance.now();
    frame = requestAnimationFrame(function (now) { root.classList.add('is-visible'); lastFrame = now; frame = requestAnimationFrame(tick); });
    announcement.textContent = 'Yeni məhsul: ' + product.title;
  }
  async function loadPage() {
    var url = localUrl(nextUrl, false);
    if (!url || feedPages.has(url)) { nextUrl = ''; return false; }
    controller = new AbortController();
    var timeout = setTimeout(function () { if (controller) controller.abort(); }, 6000);
    try {
      var response = await fetch(url, { headers: { Accept: 'application/json' }, signal: controller.signal });
      if (!response.ok) throw new Error('feed');
      var data = await response.json();
      if (data.version !== config.version || data.source !== config.source) throw new Error('campaign');
      append(data.products);
      feedPages.add(url);
      nextUrl = localUrl(data.nextUrl || '', false);
      return true;
    } catch (_) { return false; }
    finally { clearTimeout(timeout); controller = null; }
  }
  async function next() {
    if (phase !== 'idle' || blocked()) return;
    phase = 'loading';
    while (memory.index >= products.length && nextUrl) {
      if (!(await loadPage())) { phase = 'idle'; memory.nextAt = Date.now() + INTERVAL; save(); return; }
      if (!touch.matches || document.hidden) { phase = 'idle'; return; }
    }
    if (!products.length) { phase = 'idle'; memory.nextAt = Date.now() + INTERVAL; save(); return; }
    if (memory.index >= products.length) memory.index = 0;
    show(products[memory.index]);
  }
  close.addEventListener('click', function () { if (elapsed >= CLOSE_DELAY) dismiss(false); });
  root.addEventListener('keydown', function (event) { if (event.key === 'Escape' && elapsed >= CLOSE_DELAY) dismiss(false); });
  productLink.addEventListener('click', function () { if (phase === 'showing') dismiss(true); });
  all.addEventListener('click', function () { if (phase === 'showing') dismiss(true); });
  image.addEventListener('error', function () { if (phase === 'showing') dismiss(true); });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) hiddenAt = Date.now();
    else { if (hiddenAt) { memory.nextAt += Date.now() - hiddenAt; save(); } hiddenAt = 0; lastFrame = performance.now(); }
  });
  window.addEventListener('resize', place, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', place, { passive: true });
  function pollOnce() {
    if (phase === 'showing' && !document.hidden && blocked()) dismiss(true);
    if (phase === 'idle' && Date.now() >= memory.nextAt && !blocked()) next();
  }
  var poll = 0;
  function startPolling() {
    // Keep the session cooldown, with a short grace period after each page entry.
    memory.nextAt = Math.max(memory.nextAt, Date.now() + INITIAL_DELAY);
    save();
    clearInterval(poll);
    poll = setInterval(pollOnce, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startPolling, { once: true });
  else startPolling();
  window.addEventListener('pagehide', function () {
    cancelAnimationFrame(frame); clearInterval(poll); clearTimeout(exitTimer);
    if (controller) controller.abort();
    root.hidden = true; root.classList.remove('is-visible'); phase = 'idle'; hovered = false; hiddenAt = 0; save();
  });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { hiddenAt = 0; memory = readMemory(); startPolling(); } });
})();
